import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type OfferCardProps = {
  heading: string;
  ctaLabel: string;
  note: string;
  items?: string[];
  showAnchor?: boolean;
};
export function OfferCard({
  heading,
  ctaLabel,
  note,
  items,
  showAnchor = true
}: OfferCardProps) {
  return <div className="mx-auto w-full max-w-xl rounded-3xl border-2 border-gold-400 bg-white p-5 text-navy-900 shadow-[0_30px_60px_-25px_rgba(5,13,28,0.55)] md:p-8" data-id="element-176" data-mp="1j7309gl6hw0r">
      <p className="text-center text-sm font-bold uppercase tracking-[0.16em] text-gold-700" data-id="element-177" data-mp="1afj2oxsa1s7d">{heading}</p>
      <div className="mt-3 flex items-end justify-center gap-3" data-id="element-178" data-mp="15hrd4af3ui6c">
        {showAnchor && <span className="pb-3 text-xl font-semibold text-navy-900/45 line-through decoration-red-500 decoration-2" data-id="element-179" data-mp="22wvig8y6jrf8">$180</span>}
        <span className="font-serif text-7xl font-extrabold leading-none text-navy-900 md:text-8xl" data-id="element-180" data-mp="1y42dpl2poj35">$27</span>
        <span className="pb-2 text-lg font-bold text-navy-900/70" data-id="element-181" data-mp="8gl0w50dtxm9">USD</span>
      </div>
      <p className="mt-2 text-center text-sm font-semibold uppercase tracking-wider text-navy-900/60" data-id="element-182" data-mp="dee7v09ievnl">One-time payment</p>

      {items && <ul className="mt-6 space-y-2.5 border-t border-navy-900/10 pt-6" data-id="element-183" data-mp="3p30bi29tz1t">
          {items.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium" data-id="element-184" data-mp="3luzbe1jdgwjb">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-185" data-mp="3qtsnpqmxahhw">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden data-id="element-186" data-mp="3cusyohvi00l7" />
              </span>
              {item}
            </li>)}
        </ul>}

      <CTAButton label={ctaLabel} note={note} className="mt-8" data-id="element-187" data-mp="1b2obfjoy1rgt" />
      <Countdown data-id="element-188" data-mp="1b363e44kpjix" />
      <ScarcityBar data-id="element-189" data-mp="1b0jv229uyzzn" />

      <div className="mt-5 flex items-start gap-3 rounded-xl bg-cream p-4 text-sm text-navy-900/80" data-id="element-190" data-mp="1f3zroylxh0cc">
        <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden data-id="element-191" data-mp="2o0yamjq6i83l" />
        <p data-id="element-192" data-mp="2nyty5de7s0rp">
          <strong className="text-navy-900" data-id="element-193" data-mp="2j2d7ocjjlabg">Automatic currency conversion.</strong> Your price is converted to your local currency automatically, according to your country and payment provider.
        </p>
      </div>
      <p className="mt-4 flex items-center justify-center gap-2 text-xs font-medium text-navy-900/55" data-id="element-194" data-mp="2a1yiv37ddd37">
        <LockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-195" data-mp="36rxrexnisbls" /> Secure checkout · Digital product
      </p>
    </div>;
}